/**
 * Per-file import-progress channels on top of shared realtime connection.
 * Does NOT own the WebSocket lifecycle.
 *
 * Channel comes from API (`channel` on upload/list), e.g.
 * `import-excel-product-{import.id}-{customerId}`.
 *
 * @param {{ subscribe: Function, unsubscribe: Function, on: Function }} realtime
 * @param {Function} onProgress
 * @returns {{ add: Function, remove: Function, setChannels: Function, destroy: Function }}
 */
export function subscribeImportProgress(realtime, onProgress) {
  if (!realtime || typeof onProgress !== "function") {
    return {
      add: function () {},
      remove: function () {},
      setChannels: function () {},
      destroy: function () {},
    };
  }

  var channels = {};

  function add(channel) {
    var name = channel != null ? String(channel) : "";
    if (!name || channels[name]) {
      return;
    }
    channels[name] = true;
    realtime.subscribe(name);
  }

  function remove(channel) {
    var name = channel != null ? String(channel) : "";
    if (!name || !channels[name]) {
      return;
    }
    delete channels[name];
    realtime.unsubscribe(name);
  }

  function setChannels(list) {
    var next = {};
    (Array.isArray(list) ? list : []).forEach(function (channel) {
      var name = channel != null ? String(channel) : "";
      if (name) {
        next[name] = true;
      }
    });
    Object.keys(channels).forEach(function (name) {
      if (!next[name]) {
        remove(name);
      }
    });
    Object.keys(next).forEach(function (name) {
      add(name);
    });
  }

  var off = realtime.on(function (payload) {
    var eventName = String((payload && payload.event) || "").replace(/^\./, "");
    if (eventName !== "import.progress") {
      return;
    }
    var data = payload && payload.data;
    if (!data || typeof data !== "object") {
      return;
    }
    var channel =
      (payload.channel != null ? String(payload.channel) : "") ||
      (data.channel != null ? String(data.channel) : "");
    if (!channel || !channels[channel]) {
      return;
    }
    if (data.channel && String(data.channel) !== channel) {
      return;
    }
    onProgress(data);
  });

  return {
    add: add,
    remove: remove,
    setChannels: setChannels,
    destroy: function destroy() {
      if (typeof off === "function") {
        off();
      }
      Object.keys(channels).forEach(function (name) {
        remove(name);
      });
    },
  };
}
